import useBoolean from "@/hooks/useBoolean";
import { SafetyValveReport } from "@/reports/types/SafetyValveReport";
import { handleJmdDownload } from "@/reports/utils/jmd";
import { Button, Modal } from "antd";
import { forwardRef, useImperativeHandle } from "react";

interface ExportJmdButtonProps {
  displayButton?: boolean;
  formValues: SafetyValveReport;
}

export interface ExportJmdButtonRef {
  triggerExport: () => void;
}

const ExportJmdButton = forwardRef<ExportJmdButtonRef, ExportJmdButtonProps>(
  ({ formValues, displayButton = true }, ref) => {
    const { value: isJmdModalOpen, setValue: setIsJmdModalOpen } =
      useBoolean(false);

    useImperativeHandle(ref, () => ({
      triggerExport: () => setIsJmdModalOpen(true),
    }));

    return (
      <>
        {displayButton && (
          <Button type="primary" onClick={() => setIsJmdModalOpen(true)}>
            Export Tag Data
          </Button>
        )}
        <Modal
          title="Export tag machine data"
          open={isJmdModalOpen}
          onCancel={() => setIsJmdModalOpen(false)}
          onOk={async () => {
            await handleJmdDownload(formValues);
            setIsJmdModalOpen(false);
          }}
          okText="Export"
          className="antd-custom-warning-modal"
        >
          <p>
            Exporting selected fields to J21 Marking as JMD file. Blank values
            will be included as empty fields.
          </p>
        </Modal>
      </>
    );
  }
);

ExportJmdButton.displayName = "ExportJmdButton";

export default ExportJmdButton;
